<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="10">
        <div class="d-flex">
          <div class="d-inline">
            <v-btn
              class="mr-2 mb-2"
              fab
              depressed
              dark
              x-small
              :to="{ name: 'News' }">
              <v-icon dark>
                mdi-arrow-left-thick
              </v-icon>
            </v-btn>
            <span class="title">Back to news list</span>
          </div>
          <v-spacer></v-spacer>
          <div class="d-inline" v-if="!loading.detail && detaildata.length > 0">
            <ShareNetwork
              network="facebook"
              :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
              :title="detaildata[0].judul_berita"
              :description="detaildata[0].prev_berita"
              :quote="detaildata[0].prev_berita"
              hashtags="careercenter,pnb,bali"
              class="text-decoration-none mr-1">
              <v-icon large color="indigo">
                mdi-facebook
              </v-icon>
            </ShareNetwork>
            <ShareNetwork
              network="whatsapp"
              :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
              :title="detaildata[0].judul_berita"
              :description="detaildata[0].prev_berita"
              :quote="detaildata[0].prev_berita"
              hashtags="careercenter,pnb,bali"
              class="text-decoration-none">
              <v-icon large color="green">
                mdi-whatsapp
              </v-icon>
            </ShareNetwork>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="10">
        <v-card
          rounded="lg"
          outlined
          :style="'border-color: ' + maincolor">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="alertdata.show">
                <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
              </v-col>
              <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0" class="py-0">
                <v-row>
                  <v-col cols="12" md="12" class="py-0">
                    <h2 class="text-md-h4 font-weight-bold">
                      {{ detaildata[0].judul_berita ? detaildata[0].judul_berita : 'News Title' }}
                    </h2>
                    <v-chip
                      class="mr-1 my-2"
                      small
                      dark>
                      <v-icon left small>
                        mdi-calendar-range
                      </v-icon>
                      {{ detaildata[0].tgl_berita }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" md="12" v-if="detaildata[0].pic_berita">
                    <v-img
                      :lazy-src="require('../assets/default.jpg')"
                      :src="api + '/upload/news/' + detaildata[0].pic_berita">
                    </v-img>
                  </v-col>
                  <v-col cols="12" md="12" v-show="!$vuetify.breakpoint.smAndDown">
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="text--primary content-editor" v-html="detaildata[0].isi_berita"></div>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="d-flex mt-5">
                      <div class="d-inline">
                        <v-btn
                          class="mr-2 mb-2"
                          fab
                          depressed
                          dark
                          x-small
                          :to="{ name: 'News' }">
                          <v-icon dark>
                            mdi-arrow-left-thick
                          </v-icon>
                        </v-btn>
                        <span class="title">Back to news list</span>
                      </div>
                      <v-spacer></v-spacer>
                      <ShareNetwork
                        network="facebook"
                        :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
                        :title="detaildata[0].judul_berita"
                        :description="detaildata[0].prev_berita"
                        :quote="detaildata[0].prev_berita"
                        hashtags="careercenter,pnb,bali"
                        class="text-decoration-none d-inline mr-1">
                        <v-icon large color="indigo">
                          mdi-facebook
                        </v-icon>
                      </ShareNetwork>
                      <ShareNetwork
                        network="whatsapp"
                        :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
                        :title="detaildata[0].judul_berita"
                        :description="detaildata[0].prev_berita"
                        :quote="detaildata[0].prev_berita"
                        hashtags="careercenter,pnb,bali"
                        class="text-decoration-none d-inline">
                        <v-icon large color="green">
                          mdi-whatsapp
                        </v-icon>
                      </ShareNetwork>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Check',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    detaildata: [],
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      berita: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
  }),
  watch: {
    '$route.query.berita'(val) {
      if (val) {
        this.check.berita = val;
        this.getBerita();
      }
    },
  },
  mounted() {
    if (this.$route.query.berita && this.$route.query.berita !== '') {
      this.check.berita = this.$route.query.berita;
      this.getBerita();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      return this.baseurl + '' + props.href;
    },
    getBerita() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.berita) {
        this.axios
          .get(
            this.api + '/public/berita/' + this.check.berita,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
